export default __webpack_public_path__ + "static/API-Design-and-Development-29671f960265b263a036b01adae9cfc7.webp";